var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.705 47.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f16a73;}.cls-2{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essay_from_outline",
    "data-name": "Essay from outline"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23.852,
    cy: 23.852,
    r: 23.852
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.418,29.237V18.207a.79.79,0,0,0-.795-.784H20.672a.79.79,0,0,0-.8.784V29.24L24.186,26.2a.8.8,0,0,1,.923,0Zm-4.77-1.431-5.1,3.6a.8.8,0,0,1-1.257-.636V18.207a2.37,2.37,0,0,1,2.385-2.354h7.951a2.37,2.37,0,0,1,2.385,2.354V30.765a.8.8,0,0,1-1.257.636Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline);
export default __webpack_public_path__ + "static/media/outline.b7925e745a92fc207bd9bf00eaa53ceb.svg";
export { ForwardRef as ReactComponent };